/* Progressive, section-scoped enhancement. State never leaves the page. */
(() => {
  if (window.tjStampLightsInitialized) return;
  window.tjStampLightsInitialized = true;

  const setState = (section, button, lit) => {
    section.classList.toggle('is-lit', lit);
    button.setAttribute('aria-pressed', String(lit));
    button.textContent = lit ? button.dataset.lightsOff : button.dataset.lightsOn;
  };

  const initialize = (root) => {
    root.querySelectorAll('[data-tj-stamp-collection]').forEach((section) => {
      const button = section.querySelector('[data-tj-lights-toggle]');
      if (!button) return;
      setState(section, button, false);
      button.hidden = false;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-tj-lights-toggle]');
    if (!button) return;
    const section = button.closest('[data-tj-stamp-collection]');
    if (!section) return;
    setState(section, button, button.getAttribute('aria-pressed') !== 'true');
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
